
import MyActivity from '../pages/MyActivity.vue'

const myActivityRoutes = [{
    path: '/supplier-products/my-activity',
    name: 'حوزه های فعالیت من',
    component: MyActivity,
}]
export default myActivityRoutes;
